import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ClientInterface } from '../data';
import { ContractProvider } from '../providers/contract.provider';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface RemoveParticipantUseCaseParams {
    client: ClientInterface;
}

@Injectable()
export class RemoveParticipantUseCase implements UseCaseWithParam<RemoveParticipantUseCaseParams, Observable<Transaction<void>>> {
    constructor(private contractProvider: ContractProvider) {}

    bind(params: RemoveParticipantUseCaseParams): Observable<Transaction<void>> {
        return this.contractProvider.current().pipe(
            map((transaction) =>
                transaction.map(
                    (contract) => {
                        contract.holders.map((holder, idx) => {
                            if (holder.id.value === params.client.id.value) {
                                if (contract.holders.length <= 1) {
                                    return Transaction.error('error.holder-cant-delete');
                                }

                                contract.holders.splice(idx, 1);
                                return Transaction.success();
                            }
                        });

                        contract.authorized.map((authorize, idx) => {
                            if (authorize.id.value === params.client.id.value) {
                                contract.authorized.splice(idx, 1);
                                return Transaction.success();
                            }
                        });

                        let canDeleteLegalGuardian = true;

                        contract.holders.map((holder) => {
                            holder.legalGuardians.map((legalGuardian) => {
                                if (canDeleteLegalGuardian && legalGuardian.id.value === params.client.id.value) {
                                    canDeleteLegalGuardian = holder.legalGuardians && holder.legalGuardians.length > 1;
                                }
                            });
                        });

                        if (!canDeleteLegalGuardian) {
                            return Transaction.error('error.legal-guardian-cant-delete');
                        }

                        contract.holders.map((holder, idx) => {
                            holder.legalGuardians.map((legalGuardian, idx2) => {
                                if (legalGuardian.id.value === params.client.id.value) {
                                    contract.holders[idx].legalGuardians.splice(idx2, 1);
                                }
                            });
                        });

                        return Transaction.success();
                    },
                    (throwable) => Transaction.error(throwable.message)
                )
            )
        );
    }
}
